import template from "./pAdminRates.html";

export function pAdminRatesDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pAdminRatesController,
    controllerAs: 'pAdminRates',
    bindToController: true
  };

  return directive;
}

class pAdminRatesController {
  constructor(Auth, Admin, $q, Controlling, $scope, $interval, Notes) {
    'ngInject';

    this.Auth = Auth;
    this.Admin = Admin;
    this.$q = $q;
    this.Controlling = Controlling;
    this.$scope = $scope;
    this.$interval = $interval;
    this.Notes = Notes;

    this.init();

    this.fields = {
      country: "info",
      siteName: "info",
      seniorityLevel: "info",
      rate: "info",
      validFrom: "info"
    };
  }

  init() {
    this.state = 'loading';
    this.Auth.authorizeAdmin().then(
      (user) => {
        this.user = user;
        let promises = [this.Admin.getRates(), this.Admin.getSites()];
        this.$q.all(promises).then(
          (success) => {
            this.rates = success[0].data.rates;
            this.sites = success[1].data;
            this.rates.forEach(r => {
              this.sites.find(s => {
                if (s.id == r.siteId) {
                  r.country = s.country;
                  r.siteName = s.name;
                }
              });
            });
            this.rates = this.sortRates(this.rates);
            this.state = "loaded";
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );
        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  sortRates(rates) {
    var finalRates = [];

    var levels = ["Junior", "Regular", "Senior", "MiddleManager", "TopManager"];

    finalRates.sort(function(a, b) {
      return new Date(a.validFrom) - new Date(b.validFrom);
    });
    for(var i in levels) {
      finalRates = finalRates.concat(rates.filter(r => r.seniorityLevel == levels[i]));
    }

    var tempRates = [];
    var sitesName = [];
    this.sites.forEach(s => sitesName.push(s.name));
    sitesName = sitesName.sort();
    sitesName.forEach(s => {
      tempRates = tempRates.concat(finalRates.filter(r => r.siteName == s));
    });

    var countries = [];

    for (var j in this.sites) {
      if (countries.length == 0) {
        countries = countries.concat(this.sites[j].country);
      }
      else if (!countries.find(c => c == this.sites[j].country)) {
        countries = countries.concat(this.sites[j].country);
      }
    }
    countries.sort();

    var tempRatesByCountry = [];

    countries.forEach(c => {
      tempRatesByCountry = tempRatesByCountry.concat(tempRates.filter(r => {
        if (r.country == c)
          return r;
      }));
    });

    return tempRatesByCountry;
  }
}
